import { TooltipProps as MuiTooltipProps, SxProps, Theme, Tooltip, Zoom } from '@mui/material';

import React from 'react';

type TooltipProps = {
    children: React.ReactElement;
    sx?: SxProps<Theme>;
} & MuiTooltipProps;

const CustomTooltip: React.FC<TooltipProps> = ({ title, children, placement = 'bottom', open, sx }) => {
    return (
        <Tooltip
            arrow
            disableInteractive
            enterTouchDelay={0}
            leaveTouchDelay={3000}
            open={open}
            placement={placement}
            slotProps={{
                transition: { timeout: 300 },
            }}
            slots={{
                transition: Zoom,
            }}
            sx={sx}
            title={title}
        >
            {children}
        </Tooltip>
    );
};

export default CustomTooltip;
